function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="24" height="24" viewBox="0 0 24 24" {...props}><path fillRule="evenodd" d="M21.272.562L15.48 6.406 2.212 2.866 0 5.1l10.936 5.81-4.423 4.463-3.438-.426-1.75 1.764 3.901 2.07 2.051 3.935 1.75-1.765-.403-3.448 4.423-4.463L18.683 24l2.212-2.231-3.358-13.116 5.912-5.975c1.589-1.603-.609-3.698-2.177-2.116z" /></svg>;
});